import { render, staticRenderFns } from "./EditAddon.vue?vue&type=template&id=b5714f3a&scoped=true&"
import script from "./EditAddon.vue?vue&type=script&lang=js&"
export * from "./EditAddon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5714f3a",
  null
  
)

export default component.exports